import styled from "@emotion/styled";

export const DrawerSection = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  gap: 15px;
`;
